var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('i',{staticClass:"el-icon-error"}),_c('h1',[_vm._v("Unauthorized Access!")]),_c('p',[_vm._v("\n    You are not allowed to access:\n    "),_c('el-link',{attrs:{"href":_vm.oldPath},domProps:{"textContent":_vm._s(_vm.oldPath)}}),_vm._v(". Please coordinate\n    with your system administrator.\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }